import { render, staticRenderFns } from "./TypesForm.vue?vue&type=template&id=36b69381&scoped=true"
import script from "./TypesForm.vue?vue&type=script&lang=js"
export * from "./TypesForm.vue?vue&type=script&lang=js"
import style0 from "./TypesForm.vue?vue&type=style&index=0&id=36b69381&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b69381",
  null
  
)

export default component.exports